import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ReactComponent as DropdownArrowIcon } from '../../assets/icons/dropdown_arrow.svg'
import styles from './VNCategoryDropdown.module.scss'
import { ButtonBase } from '@material-ui/core'
import { setSelectedCategory } from '../ActionCreators'
import { getSelectedCategoryName } from '../../selectors/categories'
import VNCategoryDropdownModal from './VNCategoryDropdownModal'
import { isE700Device } from '../../VNAndroidSDK/Utils'

const VNCategoryDropdown = () => {
  const dispatch = useDispatch()
  const [showModal, toggleModal] = useState(false)
  const curCategoryName = useSelector(getSelectedCategoryName)

  const handleClick = (categoryId) => {
    dispatch(setSelectedCategory(categoryId))
    toggleModal(false)
  }

  const handlToggle = () => {
    toggleModal(!showModal)
  }

  return (
    <>
      {showModal && <VNCategoryDropdownModal handleClick={handleClick} handleClose={handlToggle} />}
      <ButtonBase disableRipple={isE700Device()} component="div" className={styles.wrapper} onClick={handlToggle}>
        <div className={styles.title}>
          <span className={styles.name}>{curCategoryName}</span>
        </div>
        <div className={styles.carret}>
          <DropdownArrowIcon />
        </div>
      </ButtonBase>
    </>
  )
}

export default VNCategoryDropdown
